import type { PropAsset } from "./PropAsset";

export type PropLibrary = ReadonlyMap<number, PropAsset>;

export const propLibraryBinaryConstants = {
  magic: "HAPB",
  version: 3,

  headerMagicOffset: 0,
  headerVersionOffset: 4,
  headerPaddingOffset: 6,
  headerCountOffset: 8,
  headerStringTableOffset: 12,
  headerOffsetsOffset: 16,

  headerSize: 20,

  // 32 bit variables
  recordNameOffset: 0,
  recordFbxHashOffset: 4,
  recordSmallThumbnailOffset: 8,
  recordLargeThumbnailOffset: 12,
  recordFlagsOffset: 16,

  // 64 bit variables
  recordMinXOffset: 20,
  recordMinYOffset: 28,
  recordMinZOffset: 36,
  recordMaxXOffset: 44,
  recordMaxYOffset: 52,
  recordMaxZOffset: 60,

  recordS3LocationBatchOffset: 68,
  recordS3LocationFileNameOffset2: 72,

  recordPayloadSize: 76, // Not counting the id in the beginning of the record
  recordSize: 80, // Counting the id in the beginning of the record
};

export const propLibraryBinaryFlags = {
  hasSvg: 1 << 0,
  usePropUv: 1 << 1,
  useExteriorPalettePresent: 1 << 2,
  useExteriorPaletteValue: 1 << 3,
  inReview: 1 << 4,
};
